import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { DropdownItem } from "@similarweb/ui-components";

import { StyledSignalName } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/styles";

export const StyledDropdownItem = styled(DropdownItem)`
    height: max-content;
    padding: 8px 16px;
`;

export const StyledText = styled(StyledSignalName)`
    ${mixins.setFontVariant("listItem3", colorsPalettes.carbon[300])};
`;

export const StyledSignalDataLine = styled.span`
    display: block;
    ${mixins.setFontVariant("listItem3", colorsPalettes.carbon[300])};
`;

export const StyledSignalUpperText = styled(StyledSignalName)`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon[500])};
`;

export const StyledStrongText = styled.span`
    font-weight: 700;
`;
